import React from 'react';
import { useTranslation } from 'react-i18next';
import { Share, PlusSquare, Download, X } from 'lucide-react';
import { isIos, isStandalone } from '../lib/push';

var DISMISS_KEY = 'install_banner_dismissed_until';
var DISMISS_DAYS = 30;

function isDismissed() {
  var until = Number(window.localStorage.getItem(DISMISS_KEY) || 0);
  return Date.now() < until;
}

function dismiss() {
  var until = Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000;
  window.localStorage.setItem(DISMISS_KEY, String(until));
}

// Bandeau global : propose d'ajouter GuideMatch à l'écran d'accueil.
// UNIQUEMENT iOS pour l'instant (alpha test) — Android/Chrome desktop
// supportent aussi l'installation ('beforeinstallprompt'), mais on l'ajoute
// une fois l'alpha terminée.
export default function InstallAppBanner() {
  var { t } = useTranslation();
  var [visible, setVisible] = React.useState(false);

  React.useEffect(function() {
    if (!isIos() || isStandalone() || isDismissed()) return;
    setVisible(true);
  }, []);

  function handleDismiss() {
    dismiss();
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="bg-zinc-900 border-t border-white/10 text-white px-4 py-3 flex items-center gap-3 text-sm shadow-lg" data-testid="install-app-banner">
      <Download className="h-5 w-5 text-[#00F0FF] shrink-0" />
      <span className="flex-1 flex flex-wrap items-center gap-1">
        {t('installApp.iosText1')}
        <Share className="h-4 w-4 inline text-[#00F0FF]" />
        {t('installApp.iosText2')}
        <PlusSquare className="h-4 w-4 inline text-[#00F0FF]" />
        {t('installApp.iosText3')}
      </span>
      <button onClick={handleDismiss} className="shrink-0 opacity-70 hover:opacity-100" aria-label="X">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
